var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        transition: "slide-y-transition",
        "offset-y": "",
        bottom: "",
        left: "",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var menuOn = ref.on
            return [
              _c(
                "v-btn",
                _vm._g({ attrs: { icon: "" } }, menuOn),
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c("v-icon", _vm._g({}, on), [
                                  _vm._v("mdi-apps"),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v("Acelerex apps")])]
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-card",
        { attrs: { flat: "", width: "280" } },
        [
          _c(
            "v-row",
            { staticClass: "ma-2", attrs: { "no-gutters": "" } },
            _vm._l(_vm.appList, function (app) {
              return _c(
                "v-col",
                { key: app.name, attrs: { cols: "6", "align-self": "center" } },
                [
                  _c(
                    "a",
                    { attrs: { href: app.url, target: "_blank" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "text-center card",
                          attrs: { flat: "", disabled: app.disabled },
                        },
                        [
                          app.imgUrl
                            ? _c("img", {
                                class: { disabled: app.disabled },
                                attrs: {
                                  src: _vm.getImgUrl(app.imgUrl),
                                  height: "50",
                                },
                              })
                            : app.icon
                            ? _c(
                                "v-icon",
                                {
                                  staticClass: "my-2",
                                  attrs: {
                                    "x-large": "",
                                    color: "primary",
                                    disabled: app.disabled,
                                  },
                                },
                                [_vm._v(" " + _vm._s(app.icon) + " ")]
                              )
                            : _vm._e(),
                          _c(
                            "p",
                            {
                              class:
                                "text-center text-body-2 " +
                                (app.disabled ? "text--disabled" : ""),
                            },
                            [_vm._v(" " + _vm._s(app.name) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }